import React, { useRef } from 'react';
import Modal from '../../Modal';
import ProfilePicturePicker from '../ProfilePicturePicker';
import { Container, Footer, PhotoColectorContainer, Title } from './styles';
import Button from '../../Button';

const ProfilePictureModal2 = ({
  isOpen,
  onClose,
  onConfirm,
  selector,
  className,
  user,
  change,
  setPicture,
  useLoading,
}) => {
  const childRef = useRef();
  const uploadContainerRef = useRef();

  // console.log(uploadContainerRef.current?.clientHeight);

  const handleConfirm = () => childRef.current.handleUpload();

  const [, setLoading] = useLoading;

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      selector={selector}
      className={className}
    >
      <Container>
        <Title>Atualizar Imagem de Perfil</Title>
        <PhotoColectorContainer ref={uploadContainerRef}>
          <ProfilePicturePicker
            ref={childRef}
            user={user}
            change={change}
            setPicture={setPicture}
            setLoading={setLoading}
            cropSize={uploadContainerRef.current?.clientHeight}
          />
        </PhotoColectorContainer>
        <Footer>
          <Button
            outline
            content="Cancelar"
            width={'11.3125rem'}
            height={'2.625rem'}
            onClick={onClose}
          />
          <Button
            content="Atualizar Foto"
            width={'11.3125rem'}
            height={'2.625rem'}
            onClick={handleConfirm}
          />
        </Footer>
      </Container>
    </Modal>
  );
};

export default ProfilePictureModal2;
